import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'
import { DepartmentSort } from 'Blocks'

const mapStateToProps = state => ({
  location: get(state, 'UI.location', {})
})

class MobileDepartmentsView extends Component {
  static propTypes = {
    data: PropTypes.shape({
      products: PropTypes.shape({
        aggregations: PropTypes.shape({
          departments: PropTypes.any
        })
      })
    }),
    location: PropTypes.any,
    queryString: PropTypes.any
  }

  render() {
    return (
      <div className="price-filter__filter panel">
        <DepartmentSort
          departments={this.props.data.products.aggregations.departments}
          queryString={this.props.queryString}
          location={this.props.location}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, null)(MobileDepartmentsView)
